import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { rowSelected, userCredentials } from 'recoilState/GlobalState';
import { RequestServiceGet } from 'services/services-mia/RequestServiceGet';
import { inviteParticipants as titles } from 'consts/titulos-de-tablas';
import FormSelectRol from './FormSelectRol';
import FormSignerInt from './FormSignerInt';
import FormSignerExt from './FormSignerExt';

function InsertModalParticipants({ updateList, rows, participants }) {
    const [roles, setRoles] = useState([]);
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({});
    const [signers, setSigners] = useState([]);

    const credentials = useRecoilValue(userCredentials);
    const xgridRowSelected = useRecoilValue(rowSelected);

    useEffect(() => {
        Promise.all([getRol(), getInternalSigner()]);
    }, []);

    const getRol = async () => {
        const body = { service: "SBMRolGet", params: {} };
        const response = await RequestServiceGet(body, credentials);
        setRoles(response.map((rol) => ({
            sbmRolId: rol.SBMRolId,
            sbmRolNombre: rol.SBMRolNombre
        })));
    };

    const getInternalSigner = async () => {
        const body = {
            service: "SBMFirmanteInternoGet",
            params: { sbmDocumentoId: xgridRowSelected.row.id }
        };
        const response = await RequestServiceGet(body, credentials);
        setSigners(response.map((signer) => ({
            id: signer.msuId,
            mail: signer.usuarioMail,
            usuarioId: signer.usuarioId,
            usuarioNroDocumentoX: signer.usuarioNroDeDocumentoX,
            tipoDocumentoId: signer.tipoDeDocumentoId,
            tipoDeDocumentCod: signer.tipoDeDocumentoCod,
            usuarioNroDeDocumento: signer.usuarioNroDeDocumentoX,
            usuarioNombres: signer.usuarioNombres,
            usuarioApellidos: signer.usuarioApellidos,
            [titles[0]]: `${signer.usuarioNombres} ${signer.usuarioApellidos}`,
            [titles[1]]: signer.tipoDeDocumentoNombre,
            [titles[2]]: signer.usuarioNroDeDocumentoX
        })));
    };

    const selectedRoleName = roles.find(r => String(r.sbmRolId) === String(formData.roles))?.sbmRolNombre;

    if (step === 1) {
        return (
            <FormSelectRol
                roles={roles}
                rows={rows}
                participants={participants}
                onSubmit={(value) => { setFormData(value); setStep(2); }}
            />
        );
    } else if (step === 2 && selectedRoleName === "Firmante Interno") {
        return (
            <FormSignerInt
                formData={formData}
                roles={roles}
                signers={signers}
                participants={participants}
                updateList={updateList}
            />
        );
    } else {
        return (
            <FormSignerExt
                rolData={roles.find((e) => e.sbmRolId === Number(formData.roles))?.sbmRolNombre || formData.roles}
                roles={roles}
                updateList={updateList}
                participants={participants}
            />
        );
    }
}

export default InsertModalParticipants;
